// extracted by mini-css-extract-plugin
module.exports = {"topSection":"AdminSection_topSection__3W8ni","btnContainer":"AdminSection_btnContainer__1T40z","hover":"AdminSection_hover__1-Knv"};